module.exports = __webpack_public_path__ + "img/Guardex-Logo.963292a7.png";